import React from 'react';

type Preloadable<T extends React.ComponentType<any>> =
  React.LazyExoticComponent<T> & { preload?: () => void };

export function lazyWithPreload<T extends React.ComponentType<any>>(
  factory: () => Promise<{ default: T }>
): Preloadable<T> {
  const C = React.lazy(factory) as Preloadable<T>;
  C.preload = () => { void factory(); };
  return C;
}
